"use client";

import React from "react";
import { Activity, CircleCheck, Lock, MessageCircle, Phone, Shield, ShieldCheck } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function TheTechnologicalFutureOfYourBusiness() {
  const {
    ref: textRef,
    isVisible: isTextVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: widgetRef,
    isVisible: isWidgetVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="109728" id="מענה-סיעודי-תוך-5-שעות" className="dark bg-background text-foreground relative min-h-[90vh] flex items-center overflow-hidden py-20 lg:py-0" dir="rtl">
      {}
      <div className="absolute inset-0 z-0 pointer-events-none">
        <div className="absolute inset-0 bg-[url('https://wpvc-images.s3.us-east-1.amazonaws.com/images/1626204/img/dark_network_grid.png')] opacity-5 bg-cover bg-center mix-blend-screen" />
        <div className="absolute top-1/4 right-1/4 w-[500px] h-[500px] bg-secondary/10 rounded-lg blur-[120px] opacity-40 animate-pulse" />
        <div className="absolute bottom-1/4 left-1/4 w-[400px] h-[400px] bg-accent/10 rounded-lg blur-[100px] opacity-40" />
        <div className="absolute inset-0 bg-gradient-to-b from-background/20 via-background/60 to-background" />
      </div>

      <div className="container mx-auto px-4 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          
          {}
          <div ref={textRef} className={`flex flex-col gap-8 transition-all duration-1000 transform ${isTextVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-lg bg-secondary/10 border border-secondary/20 text-secondary w-fit">
              <Activity className="w-4 h-4" />
              <span className="text-sm font-default font-medium tracking-wide">Siudy – סיעוד מיידי</span>
            </div>

            <h1 className="text-5xl md:text-[80px] font-default font-bold leading-[1.1] tracking-tighter text-foreground">
              <span className="text-secondary">מטפלת סיעודית ישראלית פרטית</span> <span className="text-white">לתקופות קצרות או ארוכות</span>
            </h1>

            <p className="text-[20px] text-muted-foreground leading-relaxed max-w-xl font-default font-light">
              <span className="text-secondary font-medium">מטפלת סיעודית פרטית</span> <span className="opacity-80">בזמינות מיידית בפריסה ארצית</span>
            </p>

            <div className="flex flex-wrap items-center gap-6 pt-4">
              <div className="relative group w-full sm:w-auto">
                <div className="absolute -inset-1 bg-gradient-to-r from-secondary to-accent rounded-xl blur opacity-30 group-hover:opacity-60 transition duration-500 animate-pulse"></div>
                <Link to="tel:0501234567" className="block w-full">
                  <Button size="lg" className="relative w-full sm:w-auto h-24 px-12 text-2xl font-bold rounded-xl bg-background border border-border hover:bg-muted text-foreground shadow-lg cursor-pointer">
                    התקשר עכשיו
                    <Phone className="w-6 h-6 mr-2 text-secondary" />
                  </Button>
                </Link>
              </div>

              <div className="relative group w-full sm:w-auto">
                <div className="absolute -inset-1 bg-gradient-to-r from-secondary to-accent rounded-xl blur opacity-30 group-hover:opacity-60 transition duration-500 animate-pulse"></div>
                <Link to="https://wa.me/972501234567" newTab className="block w-full">
                  <Button size="lg" className="relative w-full sm:w-auto h-24 px-12 text-2xl font-bold rounded-xl bg-background border border-border hover:bg-muted text-foreground shadow-lg cursor-pointer">
                    שלח וואטסאפ
                    <MessageCircle className="w-6 h-6 mr-2 text-secondary" />
                  </Button>
                </Link>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row flex-wrap items-start sm:items-center gap-x-8 gap-y-3 text-sm text-muted-foreground font-default mt-2">
              <div className="flex items-center gap-2">
                <CircleCheck className="w-5 h-5 text-secondary" />
                <span>מטפלים ישראלים מוסמכים ברמה רפואית גבוהה</span>
              </div>
              <div className="flex items-center gap-2">
                <CircleCheck className="w-5 h-5 text-secondary" />
                <span>זמינות מיידית – ממוצע הגעה 5 שעות</span>
              </div>
              <div className="flex items-center gap-2">
                <CircleCheck className="w-5 h-5 text-secondary" />
                <span>שירות בפריסה ארצית – מתל אביב לאילת</span>
              </div>
              <div className="flex items-center gap-2">
                <CircleCheck className="w-5 h-5 text-secondary" />
                <span>התאמה מדויקת לצרכים רפואיים</span>
              </div>
            </div>
          </div>

          {}
          <div ref={widgetRef} className={`relative flex flex-col items-center lg:items-end transition-all duration-1000 delay-300 transform ${isWidgetVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
            
            {}
            <div className="relative w-full max-w-md rounded-3xl border border-white/5 bg-card/40 p-8 backdrop-blur-2xl shadow-2xl overflow-hidden">
              
              {}
              <div className="absolute top-0 left-1/2 -translate-x-1/2 w-3/4 h-32 bg-secondary/10 blur-[50px] rounded-lg pointer-events-none" />

              <div className="flex items-center justify-between mb-10 relative z-10">
                <div className="flex items-center gap-3">
                  <div className="w-3 h-3 rounded-lg bg-secondary animate-pulse" />
                  <span className="text-sm font-default font-medium text-muted-foreground tracking-wider">סטטוס זמינות</span>
                </div>
                <div className="px-3 py-1 rounded-md bg-secondary/10 text-secondary text-xs font-default font-bold border border-secondary/20">
                  מענה מיידי – זמינות בשיבא תל השומר, איכילוב, בילינסון
                </div>
              </div>

              {}
              <div className="flex justify-center mb-10 relative z-10">
                <div className="relative flex items-center justify-center w-40 h-40">
                  {}
                  <div className="absolute inset-0 rounded-lg border border-secondary/30 border-t-secondary animate-[spin_4s_linear_infinite]" />
                  <div className="absolute inset-2 rounded-lg border border-accent/20 border-b-accent animate-[spin_3s_linear_infinite_reverse]" />
                  
                  {}
                  <div className="relative flex items-center justify-center w-24 h-24 rounded-2xl bg-gradient-to-br from-secondary/10 to-accent/10 border border-white/10 backdrop-blur-md shadow-inner overflow-hidden">
                    <img src="https://eternal-lobster.10web.cloud/wp-content/uploads/2026/04/smiling_israeli_caregiver.png" alt="מטפל סיעודי ישראלי מקצועי" className="w-full h-full object-cover" loading="lazy" data-wvc-srcset="https://eternal-lobster.10web.cloud/wp-content/uploads/2026/04/smiling_israeli_caregiver.png-wvc-srcset" data-wvc-sizes="https://eternal-lobster.10web.cloud/wp-content/uploads/2026/04/smiling_israeli_caregiver.png-wvc-sizes" />
                  </div>
                </div>
              </div>

              {}
              <div className="grid grid-cols-2 gap-4 relative z-10">
                <div className="flex flex-col gap-1 p-4 rounded-xl bg-black/10 border border-white/5">
                  <div className="flex items-center gap-2 text-muted-foreground mb-1">
                    <Lock className="w-4 h-4" />
                    <span className="text-xs font-default">מטפלים פעילים</span>
                  </div>
                  <span className="text-2xl font-default font-bold text-foreground">1,240</span>
                  <span className="text-[10px] font-default text-secondary">בכל רחבי הארץ</span>
                </div>
                <div className="flex flex-col gap-1 p-4 rounded-xl bg-black/10 border border-white/5">
                  <div className="flex items-center gap-2 text-muted-foreground mb-1">
                    <Shield className="w-4 h-4" />
                    <span className="text-xs font-default">זמן הגעה</span>
                  </div>
                  <span className="text-2xl font-default font-bold text-foreground">4.2 שעות</span>
                  <span className="text-[10px] font-default text-accent">ממוצע ארצי נוכחי</span>
                </div>
              </div>

            </div>

            {}
            <div className="mt-6 relative z-10 px-2">
              <Link to="/CaregiverServicePagesPage" className="text-sm text-muted-foreground hover:text-secondary transition-colors underline underline-offset-4">
                אזורי שירות נוספים
              </Link>
            </div>

            {}
            <div className="absolute -top-6 -right-6 w-24 h-24 bg-secondary/5 rounded-lg blur-2xl animate-pulse" />
            <div className="absolute -bottom-10 -left-10 w-32 h-32 bg-accent/5 rounded-lg blur-3xl animate-pulse delay-700" />
          </div>

        </div>
      </div>
    </section>;
}